module.exports = __webpack_public_path__ + "img/logoColorizedSilver.57013a99.png";